// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 22H2V2H22V22ZM12 15.5L16.25 10H7.75L12 15.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chevron-down-rectangle-filled')
export default class ChevronDownRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chevron-down-rectangle-filled',
    }
  }
}
